export const MAX_BET = {
  '0': 0,
  '1': 9000000,
  '2': 18000000,
  '3': 36000000,
}

export const MAX_BET_CL = {
  '0': 0,
  '1': 473263488,
  '2': 946526988,
  '3': 1893053888,
}

export const MAX_BET_AR = {
  '0': 0,
  '1': 665183588,
  '2': 1330367188,
  '3': 2660734288,
}

export const MAX_BET_PY = {
  '0': 0,
  '1': 3469516288,
  '2': 6939032488,
  '3': 13878064988,
}

export const VIP_LABELS = {
  '0': 'Bronze',
  '1': 'Silver',
  '2': 'Gold',
  '3': 'Platinum',
}

export const REBATES_PERCENTAGE = [
  {
    "casino": 0.6,
    'live-games': 0.4,
    'slot-games': 0.8,
    'mix-parlay': 3.0,
    'virtual-sports': 0.75,
    "sports": 0.3,
  },
  {
    "casino": 0.65,
    'live-games': 0.5,
    'slot-games': 0.87,
    'mix-parlay': 3.25,
    'virtual-sports': 0.75,
    "sports": 0.4,
  },
  {
    "casino": 0.75,
    'live-games': 0.65,
    'slot-games': 1.0,
    'mix-parlay': 3.5,
    'virtual-sports': 0.75,
    "sports": 0.5,
  },
  {
    "casino": 0.88,
    'live-games': 0.8,
    'slot-games': 1.2,
    'mix-parlay': 3.5,
    'virtual-sports': 0.75,
    "sports": 0.6,
  },
]

export const VIP_BONUS = [
  {
    'upgrade-bonus': '0',
    'monthly-bonus': '0',
    'number-of-withdraws': '10',
    'max-withdraw': '25,000',
  },
  {
    'upgrade-bonus': '114',
    'monthly-bonus': '114',
    'number-of-withdraws': '10',
    'max-withdraw': '25,000',
  },
  {
    'upgrade-bonus': '2,057',
    'monthly-bonus': '2,057',
    'number-of-withdraws': '20',
    'max-withdraw': '30,000',
  },
  {
    'upgrade-bonus': '17,605',
    'monthly-bonus': '17,605',
    'number-of-withdraws': '20',
    'max-withdraw': '30,000',
  },
]

export const VIP_BONUS_CL = [
  {
    'upgrade-bonus': '0',
    'monthly-bonus': '0',
    'number-of-withdraws': '10',
    'max-withdraw': '1,314,688',
  },
  {
    'upgrade-bonus': '5,988',
    'monthly-bonus': '5,988',
    'number-of-withdraws': '10',
    'max-withdraw': '1,314,688',
  },
  {
    'upgrade-bonus': '108,188',
    'monthly-bonus': '108,188',
    'number-of-withdraws': '20',
    'max-withdraw': '1,578,088',
  },
  {
    'upgrade-bonus': '925,788',
    'monthly-bonus': '925,788',
    'number-of-withdraws': '20',
    'max-withdraw': '1,578,088',
  },
]

export const VIP_BONUS_AR = [
  {
    'upgrade-bonus': '0',
    'monthly-bonus': '0',
    'number-of-withdraws': '10',
    'max-withdraw': '1,847,788',
  },
  {
    'upgrade-bonus': '8,488',
    'monthly-bonus': '8,488',
    'number-of-withdraws': '10',
    'max-withdraw': '1,847,788',
  },
  {
    'upgrade-bonus': '152,088',
    'monthly-bonus': '152,088',
    'number-of-withdraws': '20',
    'max-withdraw': '2,217,988',
  },
  {
    'upgrade-bonus': '1,301,188',
    'monthly-bonus': '1,301,188',
    'number-of-withdraws': '20',
    'max-withdraw': '2,217,988',
  },
]

export const VIP_BONUS_PY = [
  {
    'upgrade-bonus': '0',
    'monthly-bonus': '0',
    'number-of-withdraws': '10',
    'max-withdraw': '9,637,588',
  },
  {
    'upgrade-bonus': '43,988',
    'monthly-bonus': '43,988',
    'number-of-withdraws': '10',
    'max-withdraw': '9,637,588',
  },
  {
    'upgrade-bonus': '792,988',
    'monthly-bonus': '792,988',
    'number-of-withdraws': '20',
    'max-withdraw': '11,568,788',
  },
  {
    'upgrade-bonus': '6,786,788',
    'monthly-bonus': '6,786,788',
    'number-of-withdraws': '20',
    'max-withdraw': '11,568,788',
  },
]

export const VIP_BIRTHDAY_BONUS = ['2,100', '17,600']

export const REARRANGE: Record<number, number> = {
  0: 3,
  1: 0,
  2: 1,
  3: 2,
}
